import { ReactComponent as SpotifyIcon } from '../../../icons/spotify.svg';
import { ReactComponent as InstagramIcon } from '../../../icons/instagram.svg';
import { ReactComponent as YoutubeIcon } from '../../../icons/youtube.svg';
import { CMMetrics } from './auction-metrics.styles';
import { formatNumberUnits } from '../../../Utils/common.utils';
import { FacebookIcon } from 'react-share';

const AuctionMetrics = ({spotify, instagram, youtube, youtubeChannel, spotifyChannel, instagramChannel, facebook, facebookChanel, SymbolView = false, ...props}) => {
    return (
        <CMMetrics {...props}>
            <div className={SymbolView ? 'metric-containerSymbolView ' : 'metric-container'}>
                {youtube && (youtube !== "0" && youtube !== 0) &&
                    <div className={SymbolView ? 'ContainerPlatformmIconSymbolView' : 'ContainerPlatformmIcon' }>
                        <a href={youtubeChannel} target='_blank'><YoutubeIcon className='youtube'/></a>                    
                        <div>
                            <h5>{!isNaN(Number(youtube)) ? formatNumberUnits(youtube) : youtube} </h5>
                            <span>Number of views</span>
                        </div>
                    </div>
                }
                
                {spotify && (spotify !== "0" && spotify !== 0) &&
                   <div className={SymbolView ? 'ContainerPlatformmIconSymbolView' : 'ContainerPlatformmIcon' }>
                        <a href={spotifyChannel} target='_blank'>
                            <SpotifyIcon/>
                        </a>
                        
                        <div>
                            <h5>{ !isNaN(Number(spotify)) ?  formatNumberUnits(spotify) : spotify}</h5>
                            <span>Monthly Listeners</span>
                        </div>
                    </div>
                }

                {instagram && (instagram !== "0" && instagram !== 0) &&
                    <div className={SymbolView ? 'ContainerPlatformmIconSymbolView' : 'ContainerPlatformmIcon' }>
                        <a href={instagramChannel} target='_blank'>
                            <InstagramIcon/>
                        </a>
                        
                        <div>
                            <h5>{ !isNaN(Number(instagram)) ?  formatNumberUnits(instagram) : instagram}</h5>
                            <span>Followers</span>
                        </div>
                    </div>
                }

                {facebook && (facebook !== "0" && facebook !== 0) &&
                    <div className={SymbolView ? 'ContainerPlatformmIconSymbolView' : 'ContainerPlatformmIcon' }>
                        <a href={facebookChanel} target='_blank'>
                            <FacebookIcon />
                        </a>

                        <div>
                            <h5>{!isNaN(Number(facebook)) ? formatNumberUnits(facebook) : facebook}</h5>
                            <span>Followers</span>
                        </div>
                    </div>
                }
            </div>
        </CMMetrics>
    );
} 

export default AuctionMetrics;